"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeCategory = void 0;
var TreeCategory;
(function (TreeCategory) {
    TreeCategory[TreeCategory["GettingStarted"] = 0] = "GettingStarted";
    TreeCategory[TreeCategory["Account"] = 1] = "Account";
    TreeCategory[TreeCategory["Feedback"] = 2] = "Feedback";
    TreeCategory[TreeCategory["Project"] = 3] = "Project";
    TreeCategory[TreeCategory["Provision"] = 4] = "Provision";
    TreeCategory[TreeCategory["Environment"] = 5] = "Environment";
})(TreeCategory || (exports.TreeCategory = TreeCategory = {}));
//# sourceMappingURL=tree.js.map